import {Component, HostListener, OnInit, TemplateRef} from '@angular/core';
import {ConfigurationService} from '../../../services/configuration.service';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {ApplicationService} from '../../../services/application.service';
import {Application} from '../../../domain/onBoarding/application';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import {EDocType} from '../../../enums/EDocType';
import {Observable, Subject} from 'rxjs';
import {ApplicationBody, ApplicationStatus} from '../../../domain/onBoarding/application-body';
import {ApplicationEntity} from '../../../entity/ApplicationEntity';
import {EKycStatus} from '../../../enums/EKycStatus';
import {AccountConfiguration} from '../../../domain/configurations';

@Component({
  selector: 'app-selfie',
  templateUrl: './selfie.component.html',
  styleUrls: ['./selfie.component.scss']
})
export class SelfieComponent extends CommonComponent implements OnInit {
  selfieFileValue: File = null;
  hasSelfie = false;
  application: Application;
  appStatus: string;
  lang: string;
  webcamImage: WebcamImage = null;

  configuration: AccountConfiguration;
  public innerWidth: any;
  public cameraPerms = true;
  public errors: WebcamInitError[] = [];
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    const win = !!event ? (event.target as Window) : window;
    this.innerWidth = win.innerWidth;
  }
  constructor(
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private applicationService: ApplicationService,
    public configurationService: ConfigurationService) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = applicationService.application;
    this.onResize();
    this.lang = translate.currentLang;
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.lang = translate.currentLang;
      });
    this.configuration = configurationService.account;
  }

  ngOnInit(): void {
    scroll(0, 0);
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
    this.appStatus = this.application.body.status;
    if (this.application.body.documents) {
      for (const doc of this.application.body.documents) {
        if (doc === 'SELFIE'){
          this.hasSelfie = true;
        }
        switch (doc) {
          case 'SELFIE':
            this.hasSelfie = true;
            break;
        }
      }
    }
    this.hasSelfie ||= this.application.selfie != null;
  }

  handleImage(webcamImage: WebcamImage) {
    this.webcamImage = webcamImage;
    this.application.selfie = webcamImage.imageAsDataUrl;
    this.hasSelfie = true;
    this.application.sendSelfie = true;
    this.application.uploadedSelfie = false;
  }

  public triggerSnapshot(modal: any): void {
    this.trigger.next();
    modal.close();
  }

  onSubmit() {
    this.loadingModalOn();
    let submit = false;
    if (this.isAmericanCitizen(this.application) && this.application.body.applicationRejected) {
      submit = true;
    }
    this.applicationService.setApplication(submit, false, true).subscribe(
      (response: ApplicationBody) => {
        if (!this.application.body.applicationId) {
          this.application.body.applicationId = response.applicationId;
        }
        this.application.sendSelfie = false;
        this.loadingModalOff();
        this.application.body.status = response.status;
        this.application.body.kycStatus = response.kycStatus;
        switch (this.application.body.status){
          case ApplicationStatus.IN_PROGRESS:
            if (this.isAmericanCitizen(this.application)) {
              this.router.navigate(['/onboarding/contracts']);
            }else {
              this.router.navigate(['/onboarding/personalData']);
            }
            break;
          case ApplicationStatus.BLACK_LIST_DOCUMENTS:
            this.router.navigate(['/onboarding/photos']);
            break;
          case ApplicationStatus.BLACK_LIST_QUESTIONS:
            this.router.navigate(['/onboarding/additionalQuestions']);
            break;
          case ApplicationStatus.APPROVED:
          case ApplicationStatus.SUBMITTED:
            if (this.application.body.applicationRejected) {
              if (this.isAmericanCitizen(this.application)){
                this.router.navigate(['/onboarding/end']);
              } else {
                this.router.navigate(['/onboarding/personalData']);
              }
            } else {
              this.router.navigate(['/onboarding/contracts']);
            }
            break;
          default:
            this.loadingModalOff();
            this.msgError(this.translate.instant('onboarding.contracts-consents.error-try-again', {Default: 'Hubo un problema al generar su aplicación, por favor vuelva a intentarlo'}));
        }
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
        if (error.error.code === '4600') {
          this.applicationService.application = new ApplicationEntity();
          this.router.navigate(['/']);
        }
      }
    );
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
    this.msgError(error, this.translate.instant('onboarding.photos.cameraUsageDenied', {Default: 'Es necesario que permita el uso de su cámara web. Por favor, brinde autorización y recargue la página.'}));
    this.cameraPerms = false;
  }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  openPhotoModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }
  changeFile(idFile) {
    const file = idFile.files[0];
    if (file) {
      if (file.type === 'application/pdf' || 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
        if (file.size > 2621440) {
          this.msgWarning(this.translate.instant('onboarding.photos.invalidSize', {Default: 'El tamaño del archivo excede el máximo permitido (2.5 MB)'}));
        } else {
          this.application.selfie = file;
          this.application.sendSelfie = true;
          this.application.uploadedSelfie = true;
          this.hasSelfie = true;
        }

      }
    } else {
      this.hasSelfie = false;
      this.selfieFileValue = null;
      this.msgWarning(this.translate.instant('onboarding.photos.invalidFile', {Default: 'El formato del archivo es inválido. Debe ser JPG, JPEG o PNG.'}));
    }
  }

  onBack() {
    if (this.isAmericanCitizen(this.application)) {
      this.router.navigate(['/onboarding/personalData']);
    } else {
      this.router.navigate(['/onboarding/photos']);
    }
  }

  openInfoModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }


  protected readonly docTypes = EDocType;
}
